import "./subscribedMembListCard.scss";

import moment from "moment";
import { Fragment } from "react";
import pluralize from "pluralize";
import { ProgressBar } from "react-bootstrap";
import Typography from "../../../../../../common/Typography";
import ChevronDown from "../../../../../../assets/ChevronDown";

const SubscribedMembListCard = ({ memb, setCurrMemb }) => {
  const membership = memb?.membership;

  const isRewardBundleMemb = memb?.membership?.type === "reward_bundle";
  const isMembExpired = moment(memb?.expires_at).isBefore(moment(), "day");

  const rewardBundleImgs = [
    {
      width: 32,
      height: 32,
      type: "free_item_service",
      isShow: isRewardExist("free_item_service", memb?.rewards),
      isRedeemed: isRewardRedeemed("free_item_service", memb?.rewards),
      src: "/assets/images/membership/free_item_service.png",
    },
    {
      width: 32,
      height: 30,
      type: "amount_off",
      isShow: isRewardExist("amount_off", memb?.rewards),
      isRedeemed: isRewardRedeemed("amount_off", memb?.rewards),
      src: "/assets/images/membership/amount_off.png",
    },
    {
      width: 32,
      height: 28,
      type: "discount_off",
      isShow: isRewardExist("discount_off", memb?.rewards),
      isRedeemed: isRewardRedeemed("discount_off", memb?.rewards),
      src: "/assets/images/membership/discount_off.png",
    },
  ];

  const handleCardClick = () => {
    window.scrollTo(0, 0);
    setCurrMemb(memb);
  };

  return (
    <div onClick={handleCardClick} className="subscribed-membership-list-card">
      <div className="subscribed-membership-list-card-head">
        <Typography size="display-lg" weight="medium">
          {membership?.landing_page_settings?.title}
        </Typography>
        <ChevronDown rotate={270} width={24} height={24} color="#ffffff" />
      </div>

      <Typography customClass="membership-type" weight="medium">
        {membership?.type === "reward_bundle" ? "Rewards Bundle" : "Wallet"}
      </Typography>

      <Typography
        weight="medium"
        size="display-xl"
        customClass="redemption-count"
      >
        {membership?.type === "reward_bundle" ? (
          <>
            {memb?.total_redemption_limit - memb?.total_redemptions_till_date}{" "}
            <Typography tag="span" size="heading-lg">
              redemptions available
            </Typography>
          </>
        ) : (
          <></>
        )}
      </Typography>

      <div className="redemption-progress-div">
        <div className="redemption-numbers-row">
          <Typography size="text-sm" weight="medium">
            {memb?.total_redemptions_till_date}
          </Typography>
          <Typography size="text-sm" weight="medium">
            {memb?.total_redemption_limit}
          </Typography>
        </div>
        <ProgressBar
          now={memb?.total_redemptions_till_date}
          max={memb?.total_redemption_limit}
        />
      </div>
      {isRewardBundleMemb && (
        <div className="reward-bundle-img-row">
          {rewardBundleImgs?.map((type) =>
            type?.isShow ? (
              <img
                src={type?.src}
                alt={type.type}
                key={type?.type}
                width={type?.width}
                height={type?.height}
                className={type?.isRedeemed ? "redeemed-img" : ""}
              />
            ) : (
              <Fragment key={type?.type} />
            )
          )}
        </div>
      )}

      <Typography size="heading-lg" customClass="expiry-text">
        {isMembExpired ? "Expired" : "Expires "}{" "}
        <Typography size="heading-lg" tag="span">
          {memb?.expires_at && !isMembExpired
            ? getExpiryFromToday(memb.expires_at)
            : ""}
        </Typography>
      </Typography>
    </div>
  );
};

export default SubscribedMembListCard;

const isRewardExist = (rewardType, rewards) =>
  rewards?.some((reward) => reward?.reward_type === rewardType);

const isRewardRedeemed = (rewardType, rewards) =>
  rewards?.some(
    (reward) =>
      reward?.reward_type === rewardType &&
      reward?.redemption_limit === reward?.redemptions_till_date
  );

const getExpiryFromToday = (expires_at) => {
  const today = moment().startOf("day");
  const expiryDate = moment(expires_at).startOf("day");

  const expiresInDays = expiryDate.diff(today, "days");
  const expiresInMonths = expiryDate.diff(today, "months");
  const expiresOnText = `on ${expiryDate.format("MMM DD, YYYY")}`;

  return expiresInMonths > 0 || (expiresInMonths === 0 && expiresInDays > 7)
    ? ` in ${expiresOnText}`
    : expiresInDays === 0
    ? ` today`
    : expiresInDays > 0
    ? ` in ${expiresInDays} ${pluralize("days", expiresInDays)}`
    : "";
};
